import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconCertifiedTimestamping = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 23,
	height: 21,
	viewBox: "0 0 23 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12.073 1.11377H5.18637C4.07607 1.11377 3.01132 1.5549 2.22622 2.33999C1.44113 3.12509 1 4.18984 1 5.30014V15.7661C1 16.8763 1.44113 17.9411 2.22622 18.7262C3.01132 19.5113 4.07607 19.9525 5.18637 19.9525H17.7455C18.8558 19.9525 19.9206 19.5113 20.7057 18.7262C21.4908 17.9411 21.9319 16.8763 21.9319 15.7661V8.36658",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.97977 7.39355H1",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.13867 16.7603H10.4182",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.0152 4.8763C19.0045 4.83921 18.9864 4.80634 18.9641 4.7777L19.0152 4.8763Z",
			fill: "currentColor",
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "path-5-inside-1_793_19135",
			fill: "white",
			children: /* @__PURE__ */ _jsx("path", { d: "M16.7539 4.35357C17.5554 4.35357 18.2051 3.70387 18.2051 2.90237C18.2051 2.1009 17.5554 1.45117 16.7539 1.45117C15.9525 1.45117 15.3027 2.1009 15.3027 2.90237C15.3027 3.70387 15.9525 4.35357 16.7539 4.35357ZM16.7539 2.03165C17.234 2.03165 17.6247 2.42225 17.6247 2.90237C17.6247 3.38251 17.234 3.77309 16.7539 3.77309C16.2738 3.77309 15.8832 3.38251 15.8832 2.90237C15.8832 2.42225 16.2738 2.03165 16.7539 2.03165Z" })
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.7539 4.35357C17.5554 4.35357 18.2051 3.70387 18.2051 2.90237C18.2051 2.1009 17.5554 1.45117 16.7539 1.45117C15.9525 1.45117 15.3027 2.1009 15.3027 2.90237C15.3027 3.70387 15.9525 4.35357 16.7539 4.35357ZM16.7539 2.03165C17.234 2.03165 17.6247 2.42225 17.6247 2.90237C17.6247 3.38251 17.234 3.77309 16.7539 3.77309C16.2738 3.77309 15.8832 3.38251 15.8832 2.90237C15.8832 2.42225 16.2738 2.03165 16.7539 2.03165Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.7539 5.35357C18.1077 5.35357 19.2051 4.25616 19.2051 2.90237H17.2051C17.2051 3.15157 17.0031 3.35357 16.7539 3.35357V5.35357ZM19.2051 2.90237C19.2051 1.54862 18.1077 0.451172 16.7539 0.451172V2.45117C17.0031 2.45117 17.2051 2.65319 17.2051 2.90237H19.2051ZM16.7539 0.451172C15.4002 0.451172 14.3027 1.54862 14.3027 2.90237H16.3027C16.3027 2.65319 16.5047 2.45117 16.7539 2.45117V0.451172ZM14.3027 2.90237C14.3027 4.25616 15.4002 5.35357 16.7539 5.35357V3.35357C16.5047 3.35357 16.3027 3.15157 16.3027 2.90237H14.3027ZM16.7539 3.03165C16.6818 3.03165 16.6247 2.97454 16.6247 2.90237H18.6247C18.6247 1.86997 17.7863 1.03165 16.7539 1.03165V3.03165ZM16.6247 2.90237C16.6247 2.83021 16.6818 2.77309 16.7539 2.77309V4.77309C17.7863 4.77309 18.6247 3.93482 18.6247 2.90237H16.6247ZM16.7539 2.77309C16.8261 2.77309 16.8832 2.83023 16.8832 2.90237H14.8832C14.8832 3.9348 15.7215 4.77309 16.7539 4.77309V2.77309ZM16.8832 2.90237C16.8832 2.97452 16.8261 3.03165 16.7539 3.03165V1.03165C15.7215 1.03165 14.8832 1.86999 14.8832 2.90237H16.8832Z",
			fill: "currentColor",
			mask: "url(#path-5-inside-1_793_19135)"
		})
	]
});
export default SvgIconCertifiedTimestamping;
